import { css } from 'styled-components';

const fontPath = '/fonts/helvetica-now-for-telus';

export const fontFace = css`
  @font-face {
    font-family: 'Helvetica Now for TELUS';
    src: url(${fontPath}/HNforTELUS.woff2) format('woff2');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Helvetica Now for TELUS';
    src: url(${fontPath}/HNforTELUS-Md.woff2) format('woff2');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Helvetica Now for TELUS';
    src: url(${fontPath}/HNforTELUS-Bd.woff2) format('woff2');
    font-weight: bold;
    font-style: normal;
  }
`;
